// extracted by mini-css-extract-plugin
module.exports = {"navBar":"Menu_navBar__cLSbW","visibleMenuLink":"Menu_visibleMenuLink__VpgSv","active":"Menu_active__3ax4o","invisibleMenuLink":"Menu_invisibleMenuLink__1Hd3T"};